import {ReplaySubject, distinct} from "../observable/ReplaySubject";


export class PdqHotkeyService {
    #showPdqData = new ReplaySubject<boolean>(1)
    showPdqData = distinct(this.#showPdqData)
    toggled = false;

    constructor() {
        document.addEventListener('keydown', (e) => {
            if (e.altKey) {
                this.#showPdqData.next(true)
            }
            if (e.altKey && e.ctrlKey) {
                this.toggleView()
            }
        })
        document.addEventListener('keyup', (e) => {
            if (!this.toggled)
                this.#showPdqData.next(false)
        })
    }
    toggleView(){
        this.toggled = !this.toggled;
    }
}

export const pdqHotkeyService = new PdqHotkeyService();
export default pdqHotkeyService;